module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper",
    staticStyle: {
      "position": "fixed"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.registrationForm.registrationFormSubmitted && !_vm.registrationForm.registrationErrors) ? _c('div', [_c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password custom-response",
    class: 'custom-response-' + _vm.registrationForm.registrationFormResponseCode
  }, [_c('h1', {
    staticClass: "page-title color-1-100 text-left"
  }, [_c('span', {
    staticClass: "page-title-icon"
  }, [(_vm.registrationForm.registrationFormResponseCode === 1 ||
    _vm.registrationForm.registrationFormResponseCode === 2 ||
    _vm.registrationForm.registrationFormResponseCode === 3 ||
    _vm.registrationForm.registrationFormResponseCode === 4 ||
    _vm.registrationForm.registrationFormResponseCode === 5 ||
    _vm.registrationForm.registrationFormResponseCode === 6 ||
    _vm.registrationForm.registrationFormResponseCode === 7 ||
    _vm.registrationForm.registrationFormResponseCode === 8) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 15.002 15.002"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 15.002 15.002",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                      12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
    }
  })])] : [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.163 9.729"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.163 9.729",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "points": "10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "
    }
  })])]], 2), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 7) ? [_vm._v("\n                Your email domain is not in the list of approved domains for this company\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 8) ? [_vm._v("\n                Your email domain is not in the list of approved domains for this company\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 9) ? [_vm._v("\n                Your request was successfully sent\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 10) ? [_vm._v("\n                Your account was successfully created.\n              ")] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "page-description color-2-77 text-left"
  }, [(_vm.registrationForm.registrationFormResponseCode === 7) ? [_vm._v("\n                Use your work email if you want your account to be automatically activated. Alternatively,\n                you can submit your request and wait until it's manually approved by a company administrator.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 8) ? [_vm._v("\n                You need to use your work email to create an account.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 9) ? [_vm._v("\n                We'll send you an email with credentials and login instructions you as soon as your request\n                is approved by a company administrator.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 10) ? [_vm._v("\n                We've sent you an email with your temporary credentials."), _c('br'), _c('br'), _vm._v("\n                Please be patient, it make take a few minutes before the email arrives in your inbox.\n                If it doesn't, please look for it in the spam or junk folder as well.\n              ")] : _vm._e()], 2), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 9 || _vm.registrationForm.registrationFormResponseCode === 10) ? _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n              Have a question? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Send us your message here")]), _vm._v(".\n            ")], 1) : _c('div', {
    staticClass: "landing-page-login-info-buttons"
  }, [_c('button', {
    staticClass: "background-1-10 background-1-50-hover color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.changeEmail()
      }
    }
  }, [_vm._v("\n                Change email\n              ")]), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 7) ? _c('button', {
    staticClass: "color-2-100 border-1-50",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submitForm(true)
      }
    }
  }, [_vm._v("\n                Submit request\n              ")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.registrationForm.registrationFormSubmitted) ? _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.footerEdit = true
      }
    }
  }, [_vm._v("Edit page footer logos")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPageLogo()
      }
    }
  }, [_vm._v("Edit page logo")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd"
  }, [_c('div', {
    staticClass: "hero-pwd-text"
  }, [_vm._v("\n                Powered by\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd-logo"
  }, [(_vm.selectedHightCont != 1) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/svg/logo.svg"),
      "alt": " "
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/svg/high-contrast/logo-yellow.svg"),
      "alt": " "
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-login registration-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm(false)
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.firstName !== '' || _vm.focus === 'firstName',
      'has-error': _vm.errors.has('First name')
    }]
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.firstName),
      expression: "registrationForm.firstName"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.firstName !== '' || _vm.focus === 'firstName'
    }],
    attrs: {
      "id": "firstName",
      "type": "text",
      "data-vv-name": "First name"
    },
    domProps: {
      "value": (_vm.registrationForm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'firstName'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.lastName !== '' || _vm.focus === 'lastName',
      'has-error': _vm.errors.has('Last name')
    }]
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.lastName),
      expression: "registrationForm.lastName"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.lastName !== '' || _vm.focus === 'lastName'
    }],
    attrs: {
      "id": "lastName",
      "type": "text",
      "data-vv-name": "Last name"
    },
    domProps: {
      "value": (_vm.registrationForm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'lastName'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.email !== '' || _vm.focus === 'email',
      'has-error': _vm.errors.has('Email address')
    }]
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.email),
      expression: "registrationForm.email"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.email !== '' || _vm.focus === 'email'
    }],
    attrs: {
      "id": "email",
      "type": "email",
      "data-vv-name": "Email address"
    },
    domProps: {
      "value": (_vm.registrationForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'email'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.phone !== '' || _vm.focus === 'phone',
      'has-error': _vm.errors.has('Phone number')
    }]
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.phone),
      expression: "registrationForm.phone"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.phone !== '' || _vm.focus === 'phone'
    }],
    attrs: {
      "id": "phone",
      "type": "text",
      "data-vv-name": "Phone number"
    },
    domProps: {
      "value": (_vm.registrationForm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'phone'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.function !== '' || _vm.focus === 'function',
      'has-error': _vm.errors.has('Function')
    }]
  }, [_c('label', {
    attrs: {
      "for": "function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.function),
      expression: "registrationForm.function"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.function !== '' || _vm.focus === 'function'
    }],
    attrs: {
      "id": "function",
      "type": "text",
      "data-vv-name": "Function"
    },
    domProps: {
      "value": (_vm.registrationForm.function)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'function'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "function", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Function')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Function')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.title !== '' || _vm.focus === 'title',
      'has-error': _vm.errors.has('Title')
    }]
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.title),
      expression: "registrationForm.title"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.title !== '' || _vm.focus === 'title'
    }],
    attrs: {
      "id": "title",
      "type": "text",
      "data-vv-name": "Title"
    },
    domProps: {
      "value": (_vm.registrationForm.title)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'title'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), (_vm.registrationForm.registrationErrors) ? _c('div', {
    staticClass: "login-form-error"
  }, _vm._l((_vm.registrationForm.registrationErrors), function(error) {
    return _c('ul', {
      staticClass: "error-list"
    }, [_c('li', [_vm._v(_vm._s(error))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('button', {
    staticClass: "register background-1-10 background-1-50-hover color-2-100",
    class: [{
      'active-logging': _vm.registrationForm.registrationInProgress
    }],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "registration-form-info"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Privacy:")]), _vm._v(" Your details will be used to keep you informed about resources provided by The Clear Company.\n                  "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to find out more about the services we provide.\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "have-account"
  }, [_c('span', [_vm._v("Already have an account?")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        'name': 'company-landing',
        'params': {
          'id': _vm.industryLanding
        }
      }
    }
  }, [_vm._v("\n                    Log in here\n                  ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.stepSection.hideSection || _vm.content.stepSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.stepSection.hideSection || content.stepSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-steps landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-content background-1-100-before"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.hideSection),
      expression: "content.stepSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showStep"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.stepSection.hideSection) ? _vm._i(_vm.content.stepSection.hideSection, null) > -1 : (_vm.content.stepSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.stepSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.stepSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showStep"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-steps-text color-2-77",
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.content.stepSection.description))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.description),
      expression: "content.stepSection.description"
    }],
    staticClass: "landing-page-steps-text color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.stepSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.stepSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.decodeHtml(_vm.content.stepSection.description)))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "steps",
    staticClass: "landing-page-steps-wrapper"
  }, [_vm._l((_vm.content.stepSection.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-item",
      class: [{
        'step-active': _vm.stepActive === (index + 1)
      }, 'step__' + step.id]
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "step-item-content"
    }, [_vm._v("\n              " + _vm._s(step.text) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.text),
        expression: "step.text"
      }],
      staticClass: "step-item-content",
      attrs: {
        "data-gramm_editor": "false",
        "data-lpignore": "true",
        "placeholder": "Step item text",
        "rows": "1"
      },
      domProps: {
        "value": (step.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(step.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "step-item-image",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(step))
      }),
      attrs: {
        "title": step.altImage
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(step)
        }
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "step-item-upload"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "landing-page-steps-pagination"
  }, [_c('span', {
    staticClass: "step-item__1",
    class: [{
      'active': _vm.stepActive === 1
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__2",
    class: [{
      'active': _vm.stepActive === 2
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 2
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__3",
    class: [{
      'active': _vm.stepActive === 3
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 3
      }
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showFeatures'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.featuresSection.title) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.featuresSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.title),
      expression: "content.featuresSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.featuresSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.featuresSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.featuresSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return (index < _vm.ppp) ? _c('div', {
      ref: 'feature-' + index,
      refInFor: true,
      staticClass: "feature-item",
      class: [{
        'expanded': item.expanded && !_vm.pageEditMode
      }]
    }, [(!_vm.pageEditMode && item.expanded) ? _c('a', {
      staticClass: "feature-close border-1-50",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.date) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("Posted on " + _vm._s(_vm.getCurrentDate(item.date)))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-excerpt",
      domProps: {
        "innerHTML": _vm._s(item.excerpt)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.expanded) ? _c('div', {
      staticClass: "feature-text background-1-50-before",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.text && item.text !== '') ? _c('a', {
      staticClass: "feature-link background-1-10 background-1-50-hover color-2-100 border-1-50",
      class: [{
        'expanded': item.expanded
      }],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }, [(item.expanded) ? [_vm._v("Show less")] : [_vm._v("Show more")]], 2) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("\n                Posted on\n                "), _c('datepicker', {
      attrs: {
        "inline": false,
        "open-date": item.date,
        "format": 'dd MMMM yyyy'
      },
      model: {
        value: (item.date),
        callback: function($$v) {
          _vm.$set(item, "date", $$v)
        },
        expression: "item.date"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.excerpt),
        expression: "item.excerpt"
      }],
      staticClass: "feature-excerpt",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item excerpt",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.excerpt)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "excerpt", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.excerpt))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('wysiwyg', {
      staticClass: "feature-text edit-mode",
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list-more background-1-10 background-1-50-hover color-2-100"
  }, [(_vm.content.featuresSection.items && _vm.ppp < _vm.content.featuresSection.items.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ppp += 5
      }
    }
  }, [_vm._v("\n              Load more news\n            ")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClients"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showClients'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section center background-1-100-before"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title text-left",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description text-left",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons text-left"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && _vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action background-1-10 background-1-50-hover color-2-100",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode || _vm.content.clientSection.logos.length) ? _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mobile-left-section center background-1-100-before"
  }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && !_vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.logoEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "logoEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page logo")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "modal-item"
  }, [_c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.landing.logo)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "page-logo"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "page-logo"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.landing, 'logo')
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.footerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "footerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change footer logos")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', {
    staticClass: "footerLogos"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "logosLabel"
    }
  }, [_vm._v("Footer logos label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerData.logosLabel),
      expression: "content.footerData.logosLabel"
    }],
    attrs: {
      "id": "logosLabel"
    },
    domProps: {
      "value": (_vm.content.footerData.logosLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerData, "logosLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.content.footerData.logos), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.footerData.logos, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-logos')
      }
    }
  }, [_vm._v("+ Add logos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5739ae31","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CompanyRegistrationLanding.vue
// module id = 1000
// module chunks = 0